<template>
  <div class="home">
    <DiscoveryContent />
    <YouTubeContent />
    <UnderstandContent />
  </div>
</template>

<script>
// @ is an alias to /src
import DiscoveryContent from '@/components/DiscoveryContent.vue'
import YouTubeContent from '@/components/YouTubeContent.vue'
import UnderstandContent from '@/components/UnderstandContent.vue'

export default {
  name: 'Home',
  components: {
    DiscoveryContent,
    YouTubeContent,
    UnderstandContent
  }
}
</script>
